/**
 * <img> props for an image set in the admin's Site images page.
 *
 * image: one entry of /api/site-images/, or undefined when the admin hasn't
 * set one (then the bundled fallback file is shown).
 * sizes: how wide the image is drawn, e.g. "100vw"; with the uploaded smaller
 * versions (srcSet) it lets the browser download the lightest one that fits.
 */
export const siteImageProps = (image, fallback, sizes) => {
  if (!image?.url) {
    return { src: fallback };
  }
  const props = { src: image.url, width: image.width, height: image.height };
  if (image.sizes?.length) {
    props.srcSet = [...image.sizes, image]
      .map(({ url, width }) => `${url} ${width}w`)
      .join(", ");
    props.sizes = sizes;
  }
  if (image.alt) {
    props.alt = image.alt;
  }
  return props;
};
